<script>
	import Grid from './Grid.svelte';
	import Icon from './General/Icon.svelte';

	export let width   = '100%';
	export let cells   = [];
	export let ratio   = [0, 0];
	export let columns = 1;
	export let noBold  = false;
	export let gap     = 0;
	export let image   = '';
</script>

<div class="flex info-grid">
	<div class="grid-wrapper">
		<Grid {columns} {gap}>
			{#each cells as [key, value]}
				{#if key !== 'subTitle'}
					<div class="item" class:noBold style="--width: {width};">
						<span class="key" style="--grow: {ratio[0]}">
							{#if key === 'checkmark'}
								<Icon name="CHECKMARK" size={14} cssFill="--c-sky-blue" />
							{:else}
								{key}
							{/if}
						</span>
						<span class="value" style="--grow: {ratio[1]}">
							{#if ['checkmark', 'yes_tick'].includes(value)}
								<Icon name="CHECKMARK" size={14} cssFill="--c-sky-blue" />
							{:else}
								{value}
							{/if}
						</span>
					</div>
				{:else}
					<h4>{value}</h4>
				{/if}
			{/each}
		</Grid>
	</div>
	{#if image}
		<img src={image} alt="" />
	{/if}
</div>

<style type="text/scss" lang="scss">
	@import '../scss/mixins.scss';

	.flex {
		flex-wrap: wrap;
		flex-direction: row;
		.grid-wrapper {
			flex: 1;
		}

		/* @include small-only { */
		/* 	flex-direction: column; */
		/* } */
	}

	.item {
		width: var(--width);
		padding: 5px 0;
		display: flex;
		> * {
			flex: var(--grow);
			color: black;
			font-size: 18px;
			line-height: 23px;
			&::first-letter {
				text-transform: uppercase;
			}

			@include small-only {
				flex: 1;
			}
		}

		&.noBold {
			> * {
				font-weight: 400;
			}
		}
	}

	.key,
	.value {
		word-break: break-word;
	}

	.key {
		margin-right: 15px;
	}

	.value {
		font-weight: 700;
	}

	img {
		max-height: 300px;
		object-fit: cover;
	}

	h4 {
		grid-column-start: 1;
		font-size: 20px;
		font-weight: 600;
		margin-bottom: 5px;
		color: var(--c-primary);
		@include tablet-portrait {
			grid-column-end: 3;
		}
		@include desktop {
			grid-column-end: 4;
		}
	}
</style>
